// スムーススクロール
import { smoothScroll } from "./lib/smooth-scroll";
smoothScroll();
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// スクロールトップ
import { scrollTop } from "./lib/scroll-top";
scrollTop();

// インビュー
import { inview } from "./lib/inview";
inview();

// ドロワーメニュー
import { drawer } from "./lib/drawer";
drawer();

// モーダルウィンドウ
import { modal } from "./lib/modal";
modal();

// アコーディオン
import { accordion } from "./lib/accordion";
accordion();

// カレント表示
import { currentMenu } from "./lib/current-menu";
currentMenu();

// Online Shop Button 追従
// import { onlineshopButtonFixed } from "./lib/online-shop-button";
// onlineshopButtonFixed();

/* =================================================================

  jsが使用可能の場合classを付与

================================================================= */

document.documentElement.classList.add("is-jsEnable");

/* =================================================================

  画面幅からはみ出た要素をJavaScriptで検出する

================================================================= */

// document.querySelectorAll("*").forEach((el) => (el.clientWidth > document.body.clientWidth ? console.log(el) : null));

/* =================================================================

  読み込みが完了したらclassを付与

================================================================= */

const load = function () {
  window.addEventListener("load", () => {
    document.documentElement.classList.add("is-loaded");
    setTimeout(function () {
      document.documentElement.classList.add("is-start");
      // setTimeout(function () {
      //   document.documentElement.classList.add("is-over");
      // }, 1000);
    }, 2000);
  });
};
load();

/* =================================================================

  スクロールバーの横幅を計算

================================================================= */

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  // カスタムプロパティの値を更新する
  document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
};

// 表示されたとき
window.addEventListener("load", setScrollbarWidth);
// リサイズしたとき
window.addEventListener("resize", setScrollbarWidth);

/* =================================================================

    header変形

================================================================= */

window.addEventListener("scroll", () => {
  const headerAnimation = document.querySelector(".js-header");
  const heroSection = document.querySelector(".p-home-hero"); // 1. ヒーローエリアを取得

  // 両方の要素が存在する場合のみ実行
  if (headerAnimation && heroSection) {
    const heroHeight = heroSection.offsetHeight; // 2. ヒーローエリアの高さを取得

    // 3. スクロール量がヒーローエリアの高さを超えたらクラスを付与
    if (window.scrollY > heroHeight) {
      headerAnimation.classList.add("is-animation");
    } else {
      headerAnimation.classList.remove("is-animation");
    }
  }
});

/* =================================================================

  別ページからのリンク

================================================================= */

window.addEventListener("load", () => {
  const headerHeight = document.querySelector(".js-header").clientHeight;
  const urlHash = location.hash;

  if (urlHash) {
    const targetTop = document.querySelector(urlHash).getBoundingClientRect().top + window.pageYOffset;
    const position = targetTop - headerHeight;

    window.scrollTo({
      top: position,
      // behavior: "smooth",
    });
  }
});

/* =================================================================

  gsap

================================================================= */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();

gsap.utils.toArray(".js-mile-share-logo-move").forEach((target) => {
  gsap.from(target, {
    y: 200,
    opacity: 0,
    scrollTrigger: {
      trigger: target,
      start: "top bottom", // 開始する位置
      end: "bottom center", // 終了する位置
      scrub: 5, // スクロール量に応じてアニメーション
      markers: false,
    },
  });
});

/* =================================================================

  swiper

================================================================= */
// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
// import "swiper/css/bundle";
// import "swiper/swiper-bundle.css";

/*
  TOP メインビジュアル
--------------------------------- */

const kvSlider = new Swiper(".js-hero-slider", {
  effect: "fade",
  speed: 2000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  autoplayDisableOnInteraction: false,
  loop: true,
  slidesPerView: "auto",
  // loopAdditionalSlides: 2,
  centeredSlides: false,
  slideToClickedSlide: true,

  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
    // bulletElement: "div",
  },
});

kvSlider.on("slideChange", function () {
  const parentElement = document.querySelector(".js-hero-slider-content");
  if (kvSlider.realIndex === 0) {
    // 2枚目のスライド（インデックスは0から始まる）
    parentElement.classList.remove("is-active-black");
  } else {
    parentElement.classList.add("is-active-black");
    parentElement.classList.remove("is-active-white");
  }
});
